import { defineComponent } from 'vue'
import type { TextAreaProps } from './types'
import { FORM_INPUT_FIELD_PROPS } from '../form/input/types'
import { tv } from 'tailwind-variants'

const TextAreaClass = tv({
  base: 'block p-2.5 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-primary-500 focus:border-primary-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500',
  variants: {
    color: {
      default: '',
      gray: 'bg-gray-100'
    },
    textSize: {
      sm: 'text-sm',
      xs: 'text-xs'
    }
  }
})

const TextArea = defineComponent<TextAreaProps>({
  setup(props) {
    const handleInput = (event: Event) => {
      const target = event.target as HTMLTextAreaElement;
      if (props.dataRef) {
        props.dataRef.setValue(target.value);
      }
      if (props.onInput) {
        props.onInput(event);
      }
    }

    const textValue = computed(() => ((unref(props.value) || unref(props.dataRef?.value?.value) || '') || '') + '');

    return () => {
      return (
        <textarea
          rows={props.rows || 4}
          class={TextAreaClass({ color: props.variant as any, textSize: props.textSize || 'sm' })}
          placeholder={props.placeholder}
          onInput={handleInput}
          onBlur={props.onBlur}
          onChange={props.onChange}
          onFocus={props.onFocus}
          value={textValue.value}
        >{textValue.value}</textarea>
      )
    }
  }
})

TextArea.props = [...FORM_INPUT_FIELD_PROPS, 'rows', 'textSize']

export default TextArea;
